import classnames from 'classnames'
import React, { FC } from 'react'

import { NO_COLOR_OPTION_NAME } from '@src/quince-site-common/src/constants/app'

import { PromoConfig } from '../../../quince-site-common/src/domains/ProductVariant/PromoConfig'
import { ProductCardLink, ProductCardLinkProps } from '../product-card-actions/product-card-link'
import { useProductCardHover } from '../product-card-context/product-card-hover.context'

import { ProductPrice } from './product-price'
import styles from './product-title-section.module.scss'

export type ProductTitleSectionProps = {
  brandName?: string
  titleClassName?: string
  productPrefixPriceClassName?: string
  priceClassName?: string
  hideProductName?: boolean
  productPriceClass?: string
  productPriceWrapperClass?: string
  nameAndPriceSectionClass?: string
  productPromoConfig?: PromoConfig[] | null
  subscriptionEnabled?: boolean
} & ProductCardLinkProps

export const ProductTitleSection: FC<ProductTitleSectionProps> = props => {
  const {
    title,
    brandName,
    spid,
    selectedCardVariant,
    reviewSummary,
    productClickTrackConfig,
    slug,
    additionalAttributes,
    selectorKey,
    tracker,
    siteSearchQuery,
    productPosition,
    productSearchObjectId,
    colorVariants,
    hideProductName,
    titleClassName,
    productPriceWrapperClass,
    nameAndPriceSectionClass,
    productCardLinkClass,
    eddDetails,
    forceUnclickableHref,
  } = props

  const { setHovered } = useProductCardHover()

  const exposeColorToScreenReader =
    selectedCardVariant?.displayConfig.displayName &&
    selectedCardVariant.displayConfig.displayName.toLowerCase() !== NO_COLOR_OPTION_NAME.toLowerCase()

  return (
    <div
      className={classnames(styles.container, productPriceWrapperClass)}
      onMouseEnter={() => {
        setHovered(true)
      }}
      onMouseLeave={() => {
        setHovered(false)
      }}
    >
      <div
        className={classnames(styles.nameAndPriceSection, nameAndPriceSectionClass, hideProductName && styles.hideName)}
      >
        <div>
          <h2 className={classnames(titleClassName)}>
            <ProductCardLink
              slug={slug}
              additionalAttributes={additionalAttributes}
              selectorKey={selectorKey}
              tracker={tracker}
              productCardLinkClass={productCardLinkClass}
              selectedCardVariant={selectedCardVariant}
              siteSearchQuery={siteSearchQuery}
              productPosition={productPosition}
              productSearchObjectId={productSearchObjectId}
              title={title}
              spid={spid}
              reviewSummary={reviewSummary}
              productClickTrackConfig={productClickTrackConfig}
              colorVariants={colorVariants}
              eddDetails={eddDetails}
              product={props.product}
              onClickCb={props.onClickCb}
              forceUnclickableHref={forceUnclickableHref}
            >
              {exposeColorToScreenReader && (
                <span className="sr-only">{selectedCardVariant.displayConfig.displayName}&nbsp;</span>
              )}
              {!hideProductName && title}
            </ProductCardLink>
          </h2>
        </div>
        <ProductPrice {...props} />
      </div>
      {brandName && <div className={styles.brandNameSection}>{brandName}</div>}
    </div>
  )
}
